module.exports = __webpack_public_path__ + "img/SCOT.97b6b1ab.svg";